import React, { useEffect } from 'react';
import { MainTable } from '../../../Components/MainTable/MainTable';
import { useCategorys } from './CatStore';
import Add from './Add';
import Edit from './Edit';

function Categories(props) {
    let { categorys, columns, getCategories, deleteCategory, setEd } = useCategorys()
    useEffect(() => {
        getCategories()
    }, [])
    return (
        <MainTable
            pageTitle='Kategoriyalar'
            pcolumns={columns}
            pdata={categorys}
            add={<Add />}
            edit={<Edit />}
            defkey={'id'}
            onDelete={(e, rec) => {
                deleteCategory(rec.id)
            }}
            onEdit={(rec) => {
                setEd(rec)
            }}
            setEd={setEd}
        />
    );
}

export default Categories;